import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import FindMap from '../Pages/FindMap';
import Cookies from 'js-cookie';
import { findRangeApi, rangeApi, rangefeatureApi } from '../utils/endpoint';
import { getApi } from '../utils/api';
import { useJsApiLoader } from '@react-google-maps/api';
import PlaceComponent from './PlaceComponent';
import { generateSVGUrl } from '../utils/helpers';
import ErrorBanner from '../Pages/ErrorBanner';
// import RangeBookingForm from './RangeBookingForm';

const Map = () => {
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rangeList, setRangeList] = useState();
  const [rangefeatureList, setRangefeatureList] = useState([]);
  const [showList, setShowList] = useState({});
  const [showId, setShowId] = useState('');
  const [markerData, setMarkerData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isValidSearch, setIsValidSearch] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState({
    isError: false,
    message: '',
  });
  // const [selectedRange, setSelectedRange] = useState({});
  // const [timeoutId, setTimeoutId] = useState();
  const [geolocationData, setGeolocationData] = useState({
    lat: '',
    long: '',
  });
  const [formData, setFormData] = useState({
    city: '',
    state: '',
    zipCode: '',
    miles: 200,
  });
  const access_token = Cookies.get('userToken');
  const location = useLocation();
  const [searchLocation, setSearchLocation] = useState('');

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries: ['places'],
  });

  const handleCheckboxChange = (id) => {
    const updatedSelectedItems = selectedItems.includes(id)
      ? selectedItems.filter((itemId) => itemId !== id)
      : [...selectedItems, id];
    setSelectedItems(updatedSelectedItems);
  };

  useEffect(() => {
    fetchRangeList();
    fetchRangefeatureList();
  }, []);

  useEffect(() => {
    // Check if the Geolocation API is available
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setGeolocationData({
            lat: latitude,
            long: longitude,
          });
        },
        (error) => {
          console.error('Error getting geolocation:', error.message);
        }
      );
    } else {
      console.error('Geolocation is not supported in this browser.');
    }
  }, []);

  const fetchRangeList = () => {
    setIsLoading(true);
    getApi(rangeApi, access_token)
      .then((res) => {
        setRangeList(res?.data?.data);
        createMarkerList(res?.data?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const fetchRangefeatureList = () => {
    setIsLoading(true);
    getApi(rangefeatureApi, access_token)
      .then((res) => {
        setRangefeatureList(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const toggleShowList = (index, id) => {
    setShowList((prevShowList) => ({
      [index]: !prevShowList[index],
    }));
    setShowId(id);
  };
  const handleMarkerClick = (index, id) => {
    toggleShowList(index);
    scrollToIndex(index);
    setShowId(id);
  };

  // function scrollToIndex(index) {
  //   const container = document.getElementById('location-container');
  //   const targetItem = document.getElementById(`item${index}`);
  //   if (targetItem) {
  //     targetItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //   }
  // }

  function scrollToIndex(index) {
    const container = document.getElementById('location-container');
    if (!container) {
      console.error("Container element 'location-container' not found.");
      return;
    }

    const targetItem = document.getElementById(`item${index}`);
    if (!targetItem) {
      console.error(`Target item with ID 'item${index}' not found.`);
      return;
    }
    container.scrollTop = targetItem.offsetTop - container.offsetTop;
  }

  const executeRangeSearch = (latValue, longValue) => {
    let featureIds = '';
    selectedItems.map((item) => {
      featureIds = featureIds + `feature_ids[]=${item}&`;
      return item;
    });

    getApi(
      findRangeApi +
        `?lat=${Number(latValue)}&lng=${Number(longValue)}&${featureIds}radius=${formData.miles}`,
      access_token
    )
      .then((res) => {
        setRangeList(res?.data?.data);
        createMarkerList(res?.data?.data);
        setShow(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const geocodeAndSearch = (address) => {
    const trimmedAddress = address?.trim();

    if (!trimmedAddress || !isLoaded || !window.google?.maps?.Geocoder) {
      return false;
    }

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address: trimmedAddress }, (results, status) => {
      if (status !== 'OK' || !results || !results[0]?.geometry?.location) {
        setToastMessage({
          isError: true,
          message: 'Unable to find that location. Please refine your search.',
        });
        setShowToast(true);
        return;
      }

      const resultLocation = results[0].geometry.location;
      const lat = resultLocation.lat();
      const lng = resultLocation.lng();

      setSearchLocation(trimmedAddress);
      setGeolocationData({
        lat,
        long: lng,
      });
      setIsValidSearch(false);
      executeRangeSearch(lat, lng);
    });

    return true;
  };

  const handleApplyfilter = () => {
    let { lat, long } = geolocationData;
    executeRangeSearch(lat, long);
  };

  const handleSearch = () => {
    const trimmedLocation = searchLocation.trim();

    if (trimmedLocation) {
      if (geocodeAndSearch(trimmedLocation)) {
        return;
      }
    }

    if (!isValidSearch) {
      let { lat, long } = geolocationData;
      executeRangeSearch(lat, long);
    } else {
      fetchRangeList();
    }
  };

  useEffect(() => {
    const locationQuery =
      new URLSearchParams(location.search).get('location')?.trim() || '';

    setSearchLocation(locationQuery);

    if (!locationQuery) {
      return;
    }

    geocodeAndSearch(locationQuery);
  }, [isLoaded, location.search]);

  const handleClearfilter = () => {
    setSelectedItems([]);
    fetchRangeList();
    setShow(false);
    setFormData({
      city: '',
      state: '',
      zipCode: '',
      miles: 200,
    });
  };

  const handleJoinNow = () => {
    setToastMessage({
      isError: false,
      message: "Successfully joined! We'll be in touch soon.",
    });
    setShowToast(true);

    setTimeout(() => {
      setShowToast(false);
    }, 3500);
  };

  const handleCloseToast = () => {
    setShowToast(false);
  };

  const renderOperatingHours = (operatingHours) => {
    if (areOperatingHoursSame(operatingHours)) {
      return (
        <li>
          {`${formatTime(operatingHours[0].start_time)} - ${formatTime(
            operatingHours[0].end_time
          )}   `}
          Daily
        </li>
      );
    } else {
      return OperatingHours(operatingHours);
    }
  };

  const formatTime = (time) => {
    if (!time) {
      return 'N/A';
    }
    const trimmedTime = time.replace(/\s/g, '');
    const date = new Date(`1970-01-01T${trimmedTime}`);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours %= 12;
    hours = hours || 12; // Handle 0 as 12

    // Pad single digit minutes with leading zero
    const paddedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${hours}:${paddedMinutes} ${period}`;
  };

  const areOperatingHoursSame = (operatingHours) => {
    const isActive = operatingHours.every(
      (hours) => hours.start_time && hours.end_time
    );
    const isSameTime = operatingHours.every(
      (hours, index, array) =>
        hours.start_time === array[0].start_time &&
        hours.end_time === array[0].end_time
    );

    return isActive && isSameTime;
  };

  const OperatingHours = (operatingHours) => {
    const mergedOperatingHours = [];

    let mergedDayStart = '';
    let mergedDayEnd = '';

    operatingHours.forEach((hours, index) => {
      if (hours.closed === 1) {
        mergedOperatingHours.push({
          day: hours.day_name,
          hours: hours,
          endDay: hours.day_name,
        });
        return;
      }

      if (
        index === 0 ||
        hours.start_time !== operatingHours[index - 1].start_time ||
        hours.end_time !== operatingHours[index - 1].end_time
      ) {
        // Start a new merged day entry
        mergedDayStart = hours.day_name;
        mergedDayEnd = hours.day_name;
        mergedOperatingHours.push({
          day: mergedDayStart,
          endDay: mergedDayEnd,
          hours: hours,
        });
      } else {
        // Update the end day of the existing merged day entry
        mergedDayEnd = hours.day_name;
        mergedOperatingHours[mergedOperatingHours.length - 1].endDay =
          mergedDayEnd;
      }
    });

    return (
      <ul>
        {mergedOperatingHours.map((mergedHours, index) => (
          <li key={index}>
            <span>{`${
              mergedHours.day === mergedHours.endDay
                ? mergedHours.day
                : mergedHours.day + ' - ' + mergedHours.endDay
            } - `}</span>
            {mergedHours?.hours?.closed === 1
              ? `Closed`
              : `${formatTime(mergedHours?.hours?.start_time)} - ${formatTime(
                  mergedHours?.hours?.end_time
                )}`}
            {mergedOperatingHours?.length - 1 === index ? '' : ' | '}
          </li>
        ))}
      </ul>
    );
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const createMarkerList = (data) => {
    let dataRes = data;
    let resArray = [];
    dataRes.map((item) => {
      let obj = {};
      obj.id = item.id;
      obj.address = item.address;
      obj.phone = item.phone;
      obj.name = item.name;
      obj.lat = Number(item.lat);
      obj.lng = Number(item.lng);
      obj.range_type_color = item?.range_type_details?.color
        ? generateSVGUrl(item?.range_type_details?.color)
        : generateSVGUrl('#337ab7');

      resArray.push(obj);
    });
    setMarkerData(resArray);
  };

  return (
    <>
      <div className="map-location">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="map-select-area">
                <form className="form-input-location">
                  <PlaceComponent
                    loadError={loadError}
                    isLoaded={isLoaded}
                    setGeolocationData={setGeolocationData}
                    isValidSearch={setIsValidSearch}
                    initialValue={searchLocation}
                    onAddressChange={setSearchLocation}
                  />
                  {/* <input
                    type="city"
                    className="form-control input-outline"
                    placeholder="City"
                  />
                  <input
                    type="state"
                    className="form-control input-outline"
                    placeholder="State"
                  />
                  <input
                    type="zip"
                    className="form-control input-outline second-input"
                    placeholder="Zip"
                  /> */}
                  <button
                    className="theme-button"
                    onClick={handleSearch}
                    type="button"
                  >
                    Search
                  </button>
                  <select
                    id="state_"
                    className="form-select input-outline select-miles"
                    name="miles"
                    value={formData.miles}
                    onChange={handleInputChange}
                    required
                  >
                    <option value={200}>200 miles</option>
                    <option value={100}>100 miles</option>
                    <option value={50}>50 miles</option>
                    <option value={20}>20 miles</option>
                  </select>
                  <div className="filter-list">
                    <ul>
                      <li className="first">Ambassador Club</li>
                      <li className="first second">Premium Ranges</li>
                      <li className="first third">Partner Ranges</li>
                      <li className="first four">Participating Ranges</li>
                      <li></li>
                    </ul>
                    <div className="img-filter" onClick={() => setShow(!show)}>
                      <img
                        src="../images/bars-filter.svg"
                        alt=""
                        className="me-2"
                      />
                      {/* {show ? (
                        <i
                          className="fa fa-chevron-up"
                          aria-hidden="true"
                          style={{ color: '#4D4D4D' }}
                        ></i>
                      ) : (
                        <i
                          className="fa fa-chevron-down"
                          aria-hidden="true"
                          style={{ color: '#4D4D4D' }}
                        ></i>
                      )} */}
                      <p>Filters</p>
                    </div>

                    {/* <div className="filter-name" onClick={() => setShow(!show)}>
                  <div className="img-filter">
                    <img src="../images/filter.png" alt="" className="me-2" />
                    {show ? (
                      <i
                        className="fa fa-chevron-up"
                        aria-hidden="true"
                        style={{ color: '#4D4D4D' }}
                      ></i>
                    ) : (
                      <i
                        className="fa fa-chevron-down"
                        aria-hidden="true"
                        style={{ color: '#4D4D4D' }}
                      ></i>
                    )}
                    <p className="hover-point">Filters</p>
                  </div>
                  <ul>
                    <li className="first">Ambassador Club</li>
                    <li className="first second">Premium Ranges</li>
                    <li className="first third">Partner Ranges</li>
                    <li className="first four">Participating Ranges</li>
                    <li></li>
                  </ul>
                </div> */}
                    {show ? (
                      <div className="list-select-map">
                        <div className="filter-select">
                          <p>
                            Choose the options you&apos;d like to filter on.
                            Click &apos;Apply Filters&apos; to view results. You
                            may need to increase distance radius to see results.
                          </p>
                          <button
                            className="theme-button me-md-2 me-0 text-capitalize fw-normal d-none d-md-block"
                            onClick={handleApplyfilter}
                            type="button"
                          >
                            Apply Filters
                          </button>
                          <Link
                            className="clear-button text-capitalize fw-normal d-none d-md-block"
                            onClick={handleClearfilter}
                            type="button"
                          >
                            Clear
                          </Link>
                        </div>
                        <div className="check-list-filter">
                          {rangefeatureList?.map((item) => (
                            <div className="form-check" key={item.id}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={item.name + item.id}
                                checked={selectedItems.includes(item.id)}
                                onChange={() => handleCheckboxChange(item.id)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={item.name + item.id}
                              >
                                {item.name}
                              </label>
                            </div>
                          ))}
                        </div>
                        <button
                          className="theme-button py-2  text-capitalize fw-normal d-block d-md-none"
                          onClick={handleApplyfilter}
                          type="button"
                        >
                          Apply Filters
                        </button>
                        <Link
                          className="clear-button py-2 text-capitalize fw-normal d-block d-md-none"
                          onClick={handleClearfilter}
                          type="button"
                        >
                          Clear
                        </Link>
                      </div>
                    ) : null}
                  </div>
                </form>
              </div>
            </div>
            <div className="list-map-user">
              <div className="listing-user-set">
                {/* Totla = {rangeList?.length} */}
                {!isLoading && rangeList?.length > 0 && (
                  <div className="location-list" id="location-container">
                    {rangeList?.map((item, index) => (
                      <div
                        className="league-city bor-add-right"
                        key={index}
                        id={`item${index}`}
                      >
                        <div
                          className="city-type"
                          onClick={() => toggleShowList(index, item.id)}
                        >
                          <div className="listing-data">
                            <h4>{item.name}</h4>
                            <ul>
                              <li>{item.address}</li>
                              <li>{item.phone}</li>
                            </ul>
                          </div>
                          <div className="location-image">
                            {item.logoUrl ? (
                              <img
                                src={item.logoUrl}
                                alt=""
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = 'none';
                                  const fallback = e.target.nextElementSibling;
                                  if (fallback) fallback.style.display = 'flex';
                                }}
                              />
                            ) : null}
                            <div
                              className="range-name-placeholder"
                              style={{
                                display: item.logoUrl ? 'none' : 'flex',
                              }}
                            >
                              {item.name
                                ? item.name
                                    .split(' ')
                                    .slice(0, 2)
                                    .map((word) => word.charAt(0).toUpperCase())
                                    .join('')
                                : 'R'}
                            </div>
                          </div>
                        </div>
                        {showList[index] && showId === item.id && (
                          <div className="list-area-map">
                            {(item?.by_appointment_only ||
                              item?.range_hours?.length > 0) && (
                              <>
                                <div className="heading-listing">
                                  <h5>Hours of Operation</h5>
                                </div>
                                {item?.by_appointment_only && 'By appointment'}
                                {!item?.by_appointment_only &&
                                  item?.range_hours?.length > 0 &&
                                  renderOperatingHours(item?.range_hours)}
                              </>
                            )}{' '}
                            {item?.range_guns?.length > 0 && (
                              <>
                                <div className="heading-listing">
                                  <h5>Gun Rentals</h5>
                                </div>
                                <ul className="time-list-style k-listing">
                                  {item?.range_guns?.map((gun) => (
                                    <li key={gun.id}>{gun?.name}</li>
                                  ))}
                                </ul>
                              </>
                            )}
                            {item?.range_features?.length > 0 && (
                              <>
                                <div className="heading-listing">
                                  <h5>Features</h5>
                                </div>
                                <ul className="time-list-style k-listing">
                                  {item?.range_features?.map((range) => (
                                    <li key={range?.id}>{range?.name}</li>
                                  ))}
                                </ul>
                              </>
                            )}
                            <div className="button-link">
                              <Link
                                to={item.website}
                                className=""
                                target="_blank"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="#fff     "
                                  width="800px"
                                  height="800px"
                                  viewBox="0 0 512 512"
                                  id="Layer_1"
                                  enableBackground="new 0 0 512 512"
                                >
                                  <g>
                                    <path d="m437.02 74.98c-48.353-48.352-112.64-74.98-181.02-74.98s-132.667 26.628-181.02 74.98-74.98 112.64-74.98 181.02 26.628 132.667 74.98 181.02 112.64 74.98 181.02 74.98 132.667-26.628 181.02-74.98 74.98-112.64 74.98-181.02-26.628-132.667-74.98-181.02zm-2.132 315.679c-15.31-10.361-31.336-19.314-47.952-26.789 7.339-28.617 11.697-59.688 12.784-91.87h79.702c-3.144 44.336-19.244 85.147-44.534 118.659zm-402.31-118.659h79.702c1.088 32.183 5.446 63.254 12.784 91.87-16.616 7.475-32.642 16.427-47.952 26.789-25.29-33.512-41.39-74.323-44.534-118.659zm44.53-150.654c15.31 10.362 31.336 19.315 47.954 26.79-7.338 28.615-11.695 59.683-12.783 91.864h-79.701c3.144-44.334 19.243-85.142 44.53-118.654zm283.519-42.581c-5.863-10.992-12.198-20.911-18.935-29.713 27.069 11.25 51.473 27.658 71.977 47.997-11.625 7.638-23.702 14.369-36.155 20.185-4.886-13.664-10.528-26.547-16.887-38.469zm-12.965 50.404c-29.211 9.792-60.039 14.831-91.662 14.831s-62.451-5.039-91.662-14.831c20.463-58.253 54.273-97.169 91.662-97.169s71.199 38.916 91.662 97.169zm-203.359 110.831c1.056-28.342 4.885-55.421 10.937-80.116 32.136 10.644 66.018 16.116 100.76 16.116s68.624-5.472 100.76-16.116c6.053 24.695 9.881 51.773 10.937 80.116zm223.394 32c-1.057 28.344-4.885 55.424-10.938 80.12-32.139-10.646-66.02-16.12-100.759-16.12s-68.62 5.474-100.759 16.12c-6.053-24.696-9.882-51.776-10.938-80.12zm-216.324-193.235c-6.358 11.922-12 24.805-16.887 38.468-12.452-5.815-24.53-12.547-36.155-20.185 20.503-20.34 44.907-36.747 71.977-47.997-6.737 8.803-13.073 18.722-18.935 29.714zm-16.886 316.008c4.886 13.661 10.528 26.542 16.885 38.462 5.863 10.992 12.198 20.911 18.935 29.713-27.067-11.25-51.469-27.655-71.971-47.992 11.625-7.637 23.701-14.368 36.151-20.183zm29.853-11.938c29.213-9.794 60.04-14.835 91.66-14.835s62.447 5.041 91.66 14.835c-20.463 58.251-54.272 97.165-91.66 97.165s-71.197-38.914-91.66-97.165zm196.287 50.4c6.357-11.92 11.999-24.801 16.885-38.462 12.451 5.815 24.527 12.547 36.151 20.183-20.502 20.337-44.904 36.743-71.971 47.992 6.737-8.802 13.073-18.721 18.935-29.713zm39.093-193.235c-1.088-32.18-5.445-63.249-12.783-91.864 16.618-7.475 32.645-16.428 47.954-26.79 25.287 33.511 41.386 74.319 44.53 118.654z" />
                                  </g>
                                </svg>
                                Website
                              </Link>
                              <Link
                                to={`https://www.google.com/maps/dir/Current+Location/${Number(
                                  item.lat
                                )},${Number(item.lng)}`}
                                className="d-none"
                                target="_blank"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="800px"
                                  height="800px"
                                  viewBox="0 0 24 24"
                                  fill="#fff"
                                >
                                  <g id="SVGRepo_bgCarrier" strokeWidth="0" />

                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />

                                  <g id="SVGRepo_iconCarrier">
                                    {' '}
                                    <path
                                      d="M18.9762 5.5914L14.6089 18.6932C14.4726 19.1023 13.8939 19.1023 13.7575 18.6932L11.7868 12.7808C11.6974 12.5129 11.4871 12.3026 11.2192 12.2132L5.30683 10.2425C4.89772 10.1061 4.89772 9.52743 5.30683 9.39106L18.4086 5.0238C18.7594 4.90687 19.0931 5.24061 18.9762 5.5914Z"
                                      stroke="#fff                                  "
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />{' '}
                                  </g>
                                </svg>
                                Directions
                              </Link>
                              {access_token &&
                                (item?.by_appointment_only ||
                                item?.range_hours?.length > 0 ? (
                                  <Link
                                    to="/book-a-range"
                                    state={{ range: item }}
                                    className="book-now"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="800px"
                                      height="800px"
                                      viewBox="0 0 24 24"
                                      id="Layer_1"
                                      data-name="Layer 1"
                                      fill="#fff"
                                      className="cc"
                                    >
                                      <line
                                        className="cls-1"
                                        x1="12"
                                        y1="0.5"
                                        x2="12"
                                        y2="5.29"
                                      />
                                      <line
                                        className="cls-1"
                                        x1="12"
                                        y1="18.71"
                                        x2="12"
                                        y2="23.5"
                                      />
                                      <line
                                        className="cls-1"
                                        x1="23.5"
                                        y1="12"
                                        x2="18.71"
                                        y2="12"
                                      />
                                      <line
                                        className="cls-1"
                                        x1="5.29"
                                        y1="12"
                                        x2="0.5"
                                        y2="12"
                                      />
                                      <line
                                        className="cls-1"
                                        x1="20.13"
                                        y1="3.87"
                                        x2="16.74"
                                        y2="7.26"
                                      />
                                      <line
                                        className="cls-1"
                                        x1="7.26"
                                        y1="16.74"
                                        x2="3.87"
                                        y2="20.13"
                                      />
                                      <line
                                        className="cls-1"
                                        x1="20.13"
                                        y1="20.13"
                                        x2="16.74"
                                        y2="16.74"
                                      />
                                      <line
                                        className="cls-1"
                                        x1="7.26"
                                        y1="7.26"
                                        x2="3.87"
                                        y2="3.87"
                                      />
                                    </svg>
                                    Book Now
                                  </Link>
                                ) : (
                                  <Link
                                    className="book-now join-now-btn"
                                    onClick={handleJoinNow}
                                  >
                                    Join Waitlist
                                  </Link>
                                ))}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {!isLoading && rangeList?.length === 0 && (
                  <div className="location-list">
                    <div className="league-city">
                      <p className="error-css">No Range Found</p>
                      <p className="error-text-css">
                        Try removing or changing the filter to see results.{' '}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className="user-mpa-locating-check">
                <FindMap
                  markerData={markerData}
                  toggleShowList={handleMarkerClick}
                  isLoaded={isLoaded}
                  loadError={loadError}
                  showList={showList}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <RangeBookingForm />
        </div>
      </div> */}
      {showToast && (
        <ErrorBanner error={toastMessage} handleClose={handleCloseToast} />
      )}
    </>
  );
};

export default Map;
